import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * ローディングスピナー
 *【2ndデザイン:secondary:boolean】
 *【表示条件:visible:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-progress-spinner',
  templateUrl: './progress-spinner.html',
  styles: [`
    
  `]
})
export class ProgressSpinner extends BaseWidget {
  /**
   * 2ndデザイン
   */
  @Input() secondary:boolean

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  /**
   * デザイン状態を取得する
   *
   */
  get isSecondary() {
    if (!!this.secondary) {
      return true
    } else {
      return
    }
  }
}


// WEBPACK FOOTER //
// ./src/widgets/loading/progress-spinner/progress-spinner.component.ts